import { useState, useRef, useEffect } from 'react';
import { categories } from '@/mocks/categories';

export default function CategoryDropdown() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={ref} className="relative w-full max-w-md mx-auto" id="categories">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-5 py-3.5 bg-background-50 border border-background-300/60 rounded-lg text-foreground-800 font-medium text-sm hover:border-primary-300 transition-colors cursor-pointer"
      >
        <span>Select a Product Category</span>
        <i className={`${open ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'} text-foreground-500 transition-transform duration-200`}></i>
      </button>

      {open && (
        <div className="absolute top-full left-0 right-0 mt-1.5 bg-background-50 border border-background-200/70 rounded-lg shadow-sm z-30 max-h-72 overflow-y-auto">
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-between px-5 py-3 text-sm text-foreground-700 hover:bg-accent-50 hover:text-foreground-900 transition-colors cursor-pointer border-b border-background-100 last:border-b-0"
              onClick={() => setOpen(false)}
            >
              <span>{cat.name}</span>
              <i className="ri-arrow-right-up-line text-foreground-400 text-xs"></i>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}